import { RP_TEMPLATES } from '@Web/Pages/Web/Home/constants.jsx';
import SectionHeader from '@Web/Src/Components/SectionHeader';
import SvgSprite from '@Web/Src/Components/SvgSprite';
import LinkSection from '@Web/Src/UI/LinkSection';
import { router } from '@inertiajs/react';
import { useState } from 'react';
import LazyImage from '@Web/Src/Components/LazyImage/index.jsx';
import { assetUrl } from '@Shared/Helpers/Utilities';

function ReferralProgramsTemplates() {
    const [active, setActive] = useState(RP_TEMPLATES[0]);

    const handleTemplates = () => {
        router.visit(route('web.templates.index'));
    };

    return (
        <div className='mt-40 w-full'>
            <SectionHeader
                icon='code-file'
                title={__('Access referral program templates for every type of business')}
                desc={
                    <>
                        {__(
                            'Get access to hundreds of referral program templates when you choose Referral Factory. Find a template, edit, and launch. Templates can offer each user a '
                        )}
                        <a
                            target='_blank'
                            href='https://referral-factory.com/learn/how-to-create-a-referral-link-a-step-by-step-guide'
                            className='cursor-pointer underline'
                        >
                            {__('referral link')}
                        </a>
                        {__(' or a ')}
                        <a
                            target='_blank'
                            href='https://referral-factory.com/learn/what-is-a-referral-code'
                            className='cursor-pointer underline'
                        >
                            {__('referral code')}
                        </a>
                        .
                    </>
                }
                className='mx-auto mt-14 !max-w-[950px]'
            />
            <div className='bg-light medium:flex-wrap mx-auto mt-32 flex w-full max-w-[1100px] rounded-3xl p-4 px-4 shadow-[0px_0px_32px_0px_rgba(48,56,80,0.15)]'>
                {RP_TEMPLATES.map((item) => {
                    return (
                        <div
                            onClick={() => setActive(item)}
                            className={`bg-light medium:w-[44%] small:w-full small:justify-center medium:justify-start flex w-full cursor-pointer items-center justify-center gap-1 whitespace-nowrap rounded-3xl px-4 py-2 text-xl font-semibold ${active.header === item.header ? 'text-blue' : 'text-tertiary'}`}
                            key={item.header}
                        >
                            <SvgSprite
                                className={`!size-8`}
                                collectionName={'templates-section-sprite'}
                                iconId={item.icon}
                            />
                            <h3>{item.header}</h3>
                        </div>
                    );
                })}
            </div>
            <div className='mx-auto mt-10 box-border max-w-[920px]'>
                <LazyImage
                    className={'w-full'}
                    src={assetUrl(`/assets/images/webp/web/RP-templates/${active.icon}.webp`)}
                    lowSrc={assetUrl(
                        `/assets/images/webp/web/RP-templates/${active.icon}-low.webp`
                    )}
                    alt={active.header || 'Template'}
                />
            </div>
            <LinkSection
                handleClick={handleTemplates}
                link={__('View all referral program templates')}
                text={__('We’ve created over 100 templates')}
            />
        </div>
    );
}

export default ReferralProgramsTemplates;
